/* eslint-disable no-magic-numbers */
import { IGenerationItem, TSearchTab } from "../interfaces";

// pocet dnu
export const COOKIE_EXPIRES = 30;

export const DEF_TIMEOUT = 10000;

// vychozi cover galerie, pokud neni v galleryData uvedeny
export const GALLERY_DEFAULT_COVER = "01.webp";
// verze portretu osob v url (img/portraits) - zvysit po zmene/vymene fotky, aby se nevzala z cache
export const PERSONS_PORTRAITS_VERSION = 125;
// 5min
export const UPLOAD_TIMEOUT = 5 * 60000;

export const API_KEY = "Mui5-okocHiz_Ls5rfHV6ptSYGt7-okYvTzhMzfXu98";

export const JWT_COOKIE = "jwt";

export const INIT_SUGGEST_DATA = {
	showSuggest: false,
	useSuggest: false,
	lastPos: 0,
	suggestWord: "",
	suggestItems: [],
	suggestInd: -1,
};

export const KEYS = {
	ESC: "Escape",
	LEFT: "ArrowLeft",
	RIGHT: "ArrowRight",
	UP: "ArrowUp",
	DOWN: "ArrowDown",
	ENTER: "Enter",
	NUM_ENTER: "NumpadEnter",
	E: "e",
};

export const ROUTES = {
	OVERVIEW: `/prehled/:year`,
	MESSENGER: "/messenger",
	DANCE: "/tanec",
	SEARCH: "/hledani",
	// stare adresy - presmerovani na SEARCH
	SEARCH_EVENTS_OLD: "/hledani-udalosti",
	SEARCH_PHOTOS_OLD: "/hledani-fotek",
	SEARCH_PHOTOS_AGE_OLD: "/hledani-fotek-vek",
	GALLERY: "/udalost/:folderSeo/:nameSeo",
	GALLERY_DETAIL: "/udalost/:folderSeo/:nameSeo/:detailImage",
	LOGIN: "/prihlaseni",
	OTHERS: "/ostatni",
	CALENDAR: "/kalendar",
	IN_THIS_DAY: "/v-tento-den",
	TRACKS: "/stopy/:year",
	WORLD_MAP: "/stiraci-mapa",
	UPLOAD: "/nahravani",
	UPLOADED_FILES: "/nahrane-soubory",
	VISITS: "/pristupy",
	SALARY: "/vyplaty",
	STORY_DETAIL: "/pribeh/:story",
	STORY: "/pribeh/",
	BIRTHDAYS: "/narozeniny",
	SNAKE: "/had",
	DATA_CONTENT: "/udaje/:category",
	DATABASE_ITEMS: "/veci/:category",
	PAYMENTS: "/poplatky",
	LENKA_2024: "/lenka-2024",
	IMAGE_TESTER: "/tester-obrazku",
	GUESS: "/hadani",
	CHANGELOG: "/seznam-zmen",
	FAMILY_TREE: "/rodokmen",
	HOLIDAYS: "/dovolene",
	LINKS: "/odkazy",
	MORTAGE: "/hypoteka",
	TRAITORS: "/zradci",
	KIA: "/kia",
	FIRST_DAY: "/prvni-den",
	GROWTH: "/vyska-a-vaha",
	TITLE_PHOTOS: "/titulni-fotky",
	FACES: "/obliceje",
	TOYS: "/hracky-a-knizky",
	CHRISTMAS_TAGS: "/vanocni-cedulky",
	PORTRAITS: "/portrety",
	MISSING_PORTRAITS: "/doplnit-portrety",
	ROOT: "/",
};

// hodnota parametru "tab" na strance hledani
export const SEARCH_TABS_URL: { [key in TSearchTab]: string } = {
	events: "udalosti",
	photos: "fotky",
	persons: "osoby",
};

export const GALLERY_COUNT = 20;

export const PREV_PREV_INDEX = 2;

export const ANIM_DURATION = 10500;

export const DEFAULT_ZOOM = 17;
export const DEFAULT_MAP_POSITION = {
	x: 16.55605,
	y: 49.17603,
	z: DEFAULT_ZOOM,
};
export const MIN_ZOOM = 1;
export const MAX_ZOOM = 19;
export const BESTFIT_PADDING = { left: 60, right: 60, top: 80, bottom: 20 };

const API_BACKEND = "https://api.mapy.cz/";

export const MAPY_API_URL = `${API_BACKEND}v1`;
// url poiagregatoru
export const MAPY_POIAGG = `${API_BACKEND}poiagg`;
export const MAPY_API_ICON = `${API_BACKEND}poiimg/icon/`;
export const MAPY_ALTITUDE = `${API_BACKEND}altitude`;

export const DAYJS_FORMAT = "YYYY-MM-DD";
export const DAYJS_WITH_TIME_FORMAT = "YYYY-MM-DD H:mm";
export const DAYJS_WITH_TIME_FORMAT_FULL = "YYYY-MM-DD H:mm:ss";
export const DAYJS_NICE_FORMAT_DATE = "D. M. YYYY";
export const DAYJS_NICE_FORMAT_TIME = "D. M. YYYY H:mm:ss";
export const ALL_OVERVIEW_DATA = {
	TITLE: "Vše",
	URL: "vse",
};
// cervena, modra, zelena, zluta, fialova, oranzova "#cc0011", "#0033ff", "#006400", "#ffff6b", "#f4adf9", "#fdb918", "#00fff5"];
export const TRACK_COLORS_BY_TYPE = {
	walk: "#cc0011",
	car: "#0033ff",
	bike: "#0033ff",
	boat: "#666",
	cable: "#666",
	pubt: "#006400",
	train: "#666",
};

export const DEFAULT_UPLOAD_PREVIEW_SIZE = 200;
export const MAX_UPLOADED_SIZE_MB = 512;
export const CHUNK_SIZE_MB = 64;
export const MAX_UPLOADED_SIZE = MAX_UPLOADED_SIZE_MB * Math.pow(1024, 2);
export const WEB_DATA_URL = "/web-data/";

export const MONTHS = ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"];

export const EMPTY_DATA_CONTENT_CATEGORY = "vse";
export const MAP_ACTIVE_SVG_FILL = "#7b2882";
export const SIMPLIFY_PRECISION_CAR = 0.0001;

export const GENERATIONS: Array<IGenerationItem> = [{
	title: "Nejlepší",
	fromYear: 1901,
	toYear: 1927,
}, {
	title: "Tichá",
	fromYear: 1928,
	toYear: 1945,
}, {
	title: "Boomer",
	fromYear: 1946,
	toYear: 1964,
}, {
	title: "X",
	fromYear: 1965,
	toYear: 1980,
}, {
	title: "Miléniálové",
	fromYear: 1981,
	toYear: 1996,
}, {
	title: "Z",
	fromYear: 1997,
	toYear: 2010,
}, {
	title: "Alfa",
	fromYear: 2011,
	toYear: 2024,
}, {
	title: "Beta",
	fromYear: 2025,
	toYear: 2045,
}];

export const PERMS = {
	RODINA: 1,
	DETI: 10,
	ADMIN: 100,
};

export const ROMAN_PERMS = {
	KAMOSI: 1,
	SEZNAM: 5,
	RODINA: 10,
	ADMIN: 100,
};

export const LENKA_PERMS = {
	RODINA: 10,
	ADMIN: 100,
};

export const YEAR_DAYS = 365;
export const OVERLAP_DATA = {
	february28: "-02-28",
	february29: "-02-29",
};
export const MIN_DATE_MAKUDEROVI = "2019-11-01";
export const MIN_DATE_ROMAN = "2003-01-01";
export const MIN_DATE_LENKA = "2019-01-01";

export const MIN_YEARS = 5;

export const CROSS_SIGN = "✝";

export const EMPTY_DESC = "-";

export const ZODIAC_SIGNS: Array<{ name: string; date: number; month: number; }> = [
	{ name: 'Beran', date: 21, month: 3 },
	{ name: 'Býk', date: 21, month: 4 },
	{ name: 'Blíženci', date: 21, month: 5 },
	{ name: 'Rak', date: 21, month: 6 },
	{ name: 'Lev', date: 23, month: 7 },
	{ name: 'Panna', date: 23, month: 8 },
	{ name: 'Váhy', date: 23, month: 9 },
	{ name: 'Štír', date: 23, month: 10 },
	{ name: 'Střelec', date: 23, month: 11 },
	{ name: 'Kozoroh', date: 22, month: 12 },
	{ name: 'Vodnář', date: 20, month: 1 },
	{ name: 'Ryby', date: 20, month: 2 },
];
